module.exports = "\n<app-investment-menu></app-investment-menu>\n<div class=\"clearfix\"></div>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/investment/investment.component.html
// module id = ./src/app/investment/investment.component.html
// module chunks = main